import React, { Component } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  CircularProgress,
  Backdrop,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import agent from "../../../agent/agent";
import { DialogCreateRole } from "./components";
import { Notification, notificationTypes } from "../../../common/Notification";
import DialogConfirmation from "../../../components/DialogConfirmation";

class Roles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoading: true,
      isShowBackdrop: false,
    };

    this.refDialogCreateRole = React.createRef();
    this.refDialogConfirmation = React.createRef();
  }

  componentDidMount = async () => {
    await this.getItems();
  }

  getItems = async () => {
    this.setState({ isLoading: true });
    const response = await agent.get(`/roles`)
      .then((res) => res?.data)
      .catch((err) => {
        return { error: err?.response || true };
      });
    if (response?.error) {
      this.setState({
        items: [],
        isLoading: false,
      });
      return;
    }

    this.setState({
      items: response?.roles || [],
      isLoading: false,
    });
  }

  createRole = async (form = null) => {
    if (!form) {
      this.refDialogCreateRole.current.open({
        onSubmit: this.createRole.bind(this)
      });
      return;
    }

    this.setState({ isShowBackdrop: true });

    const response = await agent.post(`/roles`, {
      name: form.name.trim(),
      type: form.type?.trim() || null
    })
      .then((res) => res?.data)
      .catch((err) => {
        return { error: err?.response || true };
      });

    if (response?.error) {
      this.setState({ isShowBackdrop: false });
      this.refDialogCreateRole.current.resetLoading();
      Notification({
        type: notificationTypes.error,
        message: response.error?.data?.details || "Ошибка сервера"
      });
      return;
    }

    await this.getItems();
    this.refDialogCreateRole.current.close();

    Notification({
      type: notificationTypes.success,
      message: "Роль успешно создана"
    });

    this.setState({ isShowBackdrop: false });
  }
  updateRole = async (form = null, roleId = null) => {
    if (!form) {
      const editForm = { name: roleId.name, type: roleId.type || '' };
      this.refDialogCreateRole.current.open({
        onSubmit: (formData) => this.updateRole(formData, roleId.id),
        editForm: editForm
      });
      return;
    }

    this.setState({ isShowBackdrop: true });

    const response = await agent.put(`/roles/${roleId}`, {
      name: form.name.trim(),
      type: form.type?.trim() || null
    })
      .then((res) => res?.data)
      .catch((err) => {
        return { error: err?.response || true };
      });

    if (response?.error) {
      this.setState({ isShowBackdrop: false });
      this.refDialogCreateRole.current.resetLoading();
      Notification({
        type: notificationTypes.error,
        message: response.error?.data?.details || "Ошибка сервера"
      });
      return;
    }

    await this.getItems();
    this.refDialogCreateRole.current.close();

    Notification({
      type: notificationTypes.success,
      message: "Роль успешно обновлена"
    });

    this.setState({ isShowBackdrop: false });
  }
  removeRole = async (role, isConfirm) => {
    if (!isConfirm) {
      this.refDialogConfirmation.current.onOpen({
        title: "Подтверждение удаления",
        message: `Вы действительно хотите удалить роль "${role.name}"?`,
        acceptButtonTitle: "Да, удалить",
        cancelButtonTitle: "Отменить",
        acceptButtonAction: this.removeRole.bind(this, role, true),
      });
      return;
    }

    this.setState({ isShowBackdrop: true });

    const response = await agent.delete(`/roles/${role.id}`)
      .then((res) => res?.data)
      .catch((err) => {
        return { error: err?.response || true };
      });

    if (response?.error) {
      this.setState({ isShowBackdrop: false });

      let errorMessage = "Ошибка сервера";
      if (response.error?.status === 404) {
        errorMessage = "Роль не найдена";
      } else if (response.error?.status === 409) {
        errorMessage = "Роль используется и не может быть удалена";
      } else if (response.error?.data?.details) {
        errorMessage = response.error.data.details;
      }

      Notification({
        type: notificationTypes.error,
        message: errorMessage
      });
      return;
    }

    await this.getItems();
    this.setState({ isShowBackdrop: false });

    Notification({
      type: notificationTypes.success,
      message: "Роль успешно удалена"
    });
  }

  render() {
    const { items, isLoading, isShowBackdrop } = this.state;

    return (
      <>
        <Box>
          <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
            <Grid item>
              <Typography variant="h4">Роли</Typography>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => this.createRole()}
                size="small"
              >
                Создать роль
              </Button>
            </Grid>
          </Grid>

          {isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{
                backgroundColor: 'background.paper',
                borderRadius: 2,
                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
              }}
            >
              {items.length === 0 ? (
                <Box sx={{ py: 4 }}>
                  <Typography variant="body1" color="text.secondary" align="center">
                    Роли не найдены
                  </Typography>
                </Box>
              ) : (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        width={64}
                        sx={{
                          fontWeight: 600,
                          backgroundColor: 'rgba(0, 0, 0, 0.02)',
                          borderBottom: '2px solid',
                          borderColor: 'divider',
                        }}
                      >
                        ID
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          backgroundColor: 'rgba(0, 0, 0, 0.02)',
                          borderBottom: '2px solid',
                          borderColor: 'divider',
                        }}
                      >
                        Название
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          backgroundColor: 'rgba(0, 0, 0, 0.02)',
                          borderBottom: '2px solid',
                          borderColor: 'divider',
                        }}
                      >
                        Тип
                      </TableCell>
                      <TableCell
                        align="right"
                        width="100px"
                        sx={{
                          fontWeight: 600,
                          backgroundColor: 'rgba(0, 0, 0, 0.02)',
                          borderBottom: '2px solid',
                          borderColor: 'divider',
                        }}
                      >
                        Действия
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items.map((item, index) => (
                      <TableRow
                        key={item.id}
                        hover
                        sx={{
                          '&:last-child td': {
                            borderBottom: 'none',
                          },
                          '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.02)',
                          },
                          transition: 'background-color 0.2s ease',
                        }}
                      >
                        <TableCell
                          sx={{
                            borderBottom: '1px solid',
                            borderColor: 'divider',
                            py: 1.5,
                          }}
                        >
                          {item.id}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid',
                            borderColor: 'divider',
                            py: 1.5,
                            fontWeight: 500,
                          }}
                        >
                          {item.name}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid',
                            borderColor: 'divider',
                            py: 1.5,
                          }}
                        >
                          {item.type || '-'}
                        </TableCell>
                        <TableCell
                          align="right"
                          sx={{
                            borderBottom: '1px solid',
                            borderColor: 'divider',
                            py: 1.5,
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={() => this.updateRole(null, item)}
                            sx={{
                              mr: 0.5,
                              '&:hover': {
                                backgroundColor: 'rgba(25, 118, 210, 0.1)',
                              },
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => this.removeRole(item, false)}
                            color="error"
                            sx={{
                              '&:hover': {
                                backgroundColor: 'rgba(211, 47, 47, 0.1)',
                              },
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </Box>
          )}
        </Box>

        <DialogCreateRole ref={this.refDialogCreateRole} />
        <DialogConfirmation ref={this.refDialogConfirmation} />

        <Backdrop open={isShowBackdrop}>
          <CircularProgress />
        </Backdrop>
      </>
    );
  }
}

export default Roles
